export default "__VITE_ASSET__CXfN6ocE__"